import React, { useState, useEffect, useCallback } from "react";
import { useGenericWorkflowStatus, useUserWorkflowList, useWorkflowById } from "../../../../reactQuery/workflows";
import Kanban from "../../components/KanbanBoard/Kanban";
import Loader from "../../../../components/Loader";
import Avatar from "../../../../components/Avatar";
import { createAvatarName } from "../../../../utils";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CalculateCards from "./CalculateCards";
import { useUserCards } from "../../../../reactQuery/cards";
import { useSearchParams } from "react-router-dom";

const UserBoard = React.memo(({ user, userKey, setExpandAll, setExpandedRows, expandedRows, length }) => {
  const [searchParams] = useSearchParams();
  const boardId = searchParams.get("board");
  const isGeneric = searchParams.get("is_generic");
  const { userWorkflows } = useUserWorkflowList();
  const genericWorkflowId = userWorkflows?.data?.data?.responseData?.find((workflow) => workflow.is_generic)?.workflow_id;

  const { cards, refetch } = useUserCards(user.user_id, boardId, genericWorkflowId);
  const { genericWorkflowStatus: workflowData } = useGenericWorkflowStatus();

  useEffect(() => {
    refetch();
  }, [boardId, genericWorkflowId]);

  const handleChange = useCallback((userKey) => {
    if (expandedRows.includes(userKey)) {
      const newExpandedRows = expandedRows.filter((itm) => itm !== userKey);
      setExpandedRows(newExpandedRows);
      setExpandAll(false);
    } else {
      if (expandedRows.length + 1 === length) {
        setExpandAll(true);
      }
      setExpandedRows([...expandedRows, userKey]);
    }
  }, [expandedRows, length, setExpandAll, setExpandedRows]);

  return (
    <div key={userKey}>
      <Accordion
        expanded={expandedRows.includes(userKey)}
        className="accordion-allocation-board border-not-top"
        onChange={() => handleChange(userKey)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{ boxShadow: "none" }}
          className="accordian-summary-group-by-user"
        >
          <div className="justify-content-space-between d-flex w-100 align-items-center">
            <div className="d-flex">
              <Avatar
                username={`${user.first_name} ${user.last_name}`}
                user_image={user.user_image}
                title={`${user.first_name} ${user.last_name}`}
                className="user-avtar-dropdown user-avatar"
                style={{
                  bgcolor: user?.profile_color?.background,
                  color: user?.profile_color?.text,
                }}
              >
                {createAvatarName(`${user.first_name} ${user.last_name}` || "")}
              </Avatar>
              <p className="user-heading-name">
                {user.first_name} {user.last_name}
              </p>
            </div>
            <div>
              {workflowData && cards && (
                <CalculateCards
                  cards={cards?.data?.data.responseData}
                  workflowSteps={workflowData?.data?.data?.responseData
                    ?.filter((el) => !el.is_completed)
                    .sort((a, b) => a.step_sequence - b.step_sequence)}
                  isExpand={expandedRows.includes(userKey)}
                />
              )}
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          {workflowData && cards ? (
            cards.data.data.responseData.length > 0 ? (
              <Kanban
                cards={cards?.data?.data.responseData}
                workflowSteps={workflowData?.data?.data?.responseData
                  ?.filter((el) => !el.is_completed)
                  .sort((a, b) => a.step_sequence - b.step_sequence)}
              />
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                No tasks available
              </div>
            )
          ) : (
            <div className="loader-center">
              <Loader color={"black"} />
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
});

export default UserBoard;
